import { Member } from '@nextforce/api'
import { makeStyles, Text } from '@rneui/themed'
import { font } from 'app/theme'
import React, { useCallback } from 'react'
import { View } from 'react-native'
import { PressableOpacity } from 'shared/components/pressable_opacity'
import { UserAvatar } from 'shared/components/user/user_avatar'

interface Props {
  member: Member
  onRemoved?: (member: Member) => void
}

export const MEMBER_SLUG_WIDTH = 80

export function MemberSlug({ member, onRemoved }: Props) {
  const styles = useStyles()
  const onPress = useCallback(() => onRemoved!(member), [member, onRemoved])

  return (
    <View style={styles.container}>
      <UserAvatar user={member} size={'medium'} showAvatarIfNoPhone={true} />
      {onRemoved && (
        <PressableOpacity style={styles.removeButton} onPress={onPress}>
          <Text style={styles.removeButtonText}>X</Text>
        </PressableOpacity>
      )}
      <Text
        style={styles.name}
        numberOfLines={1}
      >{`${member.firstName} ${member.lastName}`}</Text>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: MEMBER_SLUG_WIDTH,
    paddingHorizontal: 10,
  },
  name: {
    fontSize: 10,
  },
  avatar: {
    width: 48,
    height: 48,
    borderRadius: 48 / 2,
    marginBottom: 5,
  },
  removeButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    backgroundColor: theme.colors?.grey3,
    width: 20,
    height: 20,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  removeButtonText: {
    fontSize: 10,
    fontFamily: font.bold,
    color: theme.colors?.white,
  },
}))
